export const labels = {
  congrats: {
    eng: 'Congratulations',
    swe: 'Grattis',
  },
  active_session: {
    eng: 'Active session',
    swe: 'Aktiv session',
  },
  track: {
    eng: 'Track',
    swe: 'Bana',
  },
  search_for_attendee: {
    eng: 'Search for my name',
    swe: 'Sök efter mitt namn',
  },
  start: {
    eng: 'Start',
    swe: 'Starta',
  },
  lets_go: {
    eng: 'Let\'s go and dribble on!',
    swe: 'Kör hårt och dribbla på!',
  },
  stop: {
    eng: 'Stop',
    swe: 'Stoppa',
  },
  stopped: {
    eng: 'Stopped',
    swe: 'Stoppad',
  },
  no_active_session: {
    eng: 'No active session',
    swe: 'Det finns ingen aktiv session',
  },
  no_question_available: {
    eng: 'No question available',
    swe: 'Ingen fråga tillgänglig',
  },
  no_more_questions: {
    eng: 'No more questions, proceed to the next station!',
    swe: 'Inga fler frågor, forsätt till nästa station!',
  },
  correct_answer: {
    eng: 'Correct answer! Continue to the next station!',
    swe: 'Rätt svar! Forsätt till nästa station!',
  },
  sync_list: {
    eng: 'Update list',
    swe: 'Uppdatera lista',
  },
  refresh_list_helptext: {
    swe: 'Om du inte hittar ditt namn, uppdatera listan genom att klicka på knappen.',
    eng: 'If you can\'t find your name, refresh the list by clicking the button.',
  }
} as const;
